import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app';
import './index.css';
import { handleMsalPopupRedirectBridge } from './lib/msal-popup-bridge';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Missing #root element in document.');
}

void (async () => {
  const handledPopupRedirect = await handleMsalPopupRedirectBridge();
  if (handledPopupRedirect) {
    return;
  }

  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
})();
